import { render, staticRenderFns } from "./BaseNotificationGlobal.vue?vue&type=template&id=13332f8a&scoped=true&"
import script from "./BaseNotificationGlobal.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationGlobal.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationGlobal.vue?vue&type=style&index=0&id=13332f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13332f8a",
  null
  
)

export default component.exports